<template>
  <div class="rapt">
    <div class="rapt_content">
      <div class="rapt_top">
        <div class="rapt_logo">
          <i class="mdi mdi-table-edit rapt_logo_icon"></i>
        </div>
        <div class="rapt_top_transformed">
          <div class="ra_table no-events t-left">
            <div
              v-for="(s, idx) in grouping === 'swv_grouping_none' ? leftAll : left"
              :key="`${idx}_l`"
              class="rtc_local"
              :style="s.s"
            ></div>
          </div>
          <div class="ra_table no-events t-right">
            <div
              v-for="(s, idx) in grouping === 'swv_grouping_none' ? rightAll : right"
              :key="`${idx}_l`"
              class="rtc_local"
              :style="s.s"
            ></div>
          </div>
        </div>
      </div>
      <div
        v-if="history_spot"
        class="d-flex f-center"
        style="font-size: 1rem"
      >
        <div class="weight_500 mr-2 clr-grey position-relative">{{ $t('common.difficulty') }}:</div>

        <Checkbox
          v-for="difficulty in difficulties"
          :key="difficulty.value"
          :asRadio="true"
          class="clr-grey mr-2"
          :value="grouping === difficulty.value"
          @input="setDifficulty(difficulty.value)"
        >
          <template
            v-if="difficulty.value === 'swv_grouping_none'"
            #content
          >
            <div
              class="csst_content clr-white"
              style="min-width: 320px; top: -3.5em"
            >
              {{ $t('tooltips.range_builder_complex_disabled') }}
            </div>
          </template>
          {{ $t(`common.${difficulty.label}`) }}
        </Checkbox>

        <i
          tour="rbhelp"
          style="line-height: 1"
          class="ml-2 my-auto clr-grey mdi mdi-help-circle-outline icon_btn text-semi-large pa-1"
          @click="$store.dispatch('router_set_dialogs', 'range-builder-help-dialog')"
        ></i>
      </div>
      <div
        v-if="history_spot"
        class="rapt_btn-start f-center f-column"
        style="margin-top: 1.75em; font-size: 1rem"
      >
        <div
          class="gw_btn_primary gw_btn-v1"
          style="font-size: 1.125em; padding: 0 1em"
          @click="start"
        >
          {{ $t('btn.start_range_build') }}
        </div>

        <div class="mt-4 clr-grey px-4 text-medium">
          {{ $t('messages.select_spot_to_range_build') }}
        </div>
      </div>
      <div
        v-else
        class="mt-4"
      >
        <v-progress-circular
          data-tst="range-table_loader"
          :model-value="90"
          :size="75"
          :indeterminate="true"
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>
<script>
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import { sendGaEvent } from '@gto/analytics/google-analytics'
import startTables from './startTables.json'

export default {
  name: 'RangeBuilderStart',
  components: {
    Checkbox,
  },
  emits: ['start'],
  data() {
    this.left = startTables.left
    this.right = startTables.right
    this.leftAll = startTables.leftAll
    this.rightAll = startTables.rightAll
    return {
      difficulties: [
        { value: 'swv_grouping_all', label: 'easy' },
        { value: 'swv_grouping_4', label: 'medium' },
        { value: 'swv_grouping_none', label: 'hard' },
      ],
    }
  },
  methods: {
    sendGaEvent,
    setDifficulty(value) {
      this.$store.dispatch('switchers_set_item_by_value', {
        key: 'sw_actions_grouping',
        value,
      })
    },
    start() {
      this.sendGaEvent({
        event: 'range_builder_started',
        difficulty: this.difficulties.find(d => d.value === this.grouping)?.label,
      })
      this.$emit('start')
    },
  },
  computed: {
    history_spot() {
      return this.$store.getters.history_spot
    },
    grouping() {
      return this.$store.getters.sw_actions_grouping
    },
  },
}
</script>
<style lang="scss" scoped>
.rapt {
  font-size: 1rem;
  flex: 1;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: clamp(1px, 1rem, 1.35vh);
    position: absolute;
    top: min(calc(100vw - 7rem), 20em);
  }
}
.rapt_top {
  position: relative;
  height: 20.5em;
  width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 2.5rem 0;
  &_transformed {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    flex: 1;
    // safari hack stacking context otherwise logo in back ignoring z-index
    transform: translate(0, 0);
  }
}
.rapt_logo {
  position: absolute;
  z-index: 3;
  background: var(--clr-black-0);
  height: 7.5em;
  width: 7.5em;
  // margin-bottom: 3.88em;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0px 2px 5px 0px #121212;
  transform: perspective(0) rotateY(0deg);
  &_icon {
    color: var(--clr-blue);
    font-size: 5em;
    position: relative;
    line-height: 1;
  }
}
.t-left {
  z-index: -1;
  position: absolute;
  left: 0;
  height: 18em;
  width: 18em;
  background: var(--clr-black-0);
  transform: perspective(600px) rotateY(35deg);
}
.t-right {
  z-index: -1;
  position: absolute;
  right: 0;
  height: 18em;
  width: 18em;
  background: var(--clr-black-0);
  transform: perspective(600px) rotateY(-35deg) scaleX(-1);
}
.ra_table {
  &:before {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
  flex: 1;
  &:first-child {
    margin: 0 !important;
  }
  display: grid;
  grid-template-columns: repeat(13, 1fr);
  grid-template-rows: repeat(13, 1fr);
  grid-gap: 1px;
  border-radius: 8px;
  overflow: hidden;
  .rtc_local {
    background-repeat: no-repeat;
    background-position-y: 100%;
    position: relative;
    z-index: 0;
    background-color: var(--clr-black-1);
    flex-shrink: 0;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }
}
@media (max-width: 1023px) {
  .rapt_top {
    margin: auto;
  }
}
</style>
